<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Mitarbeiter</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createemployee')">Mitarbeiter anlegen</b-button>
                </b-col>
                <b-col>
                    <b-button variant="warning" @click="showModal('modal-startemployeesync')">Stammdaten Import</b-button>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="employees != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="employees" :fields="fields">
                        <template slot="employeePicture" slot-scope="row">
                            <b-img-lazy center rounded="circle" width=30 height=30 fluid :src="buildEmployeePictureUrl(row.item.id)" alt="Image 1"></b-img-lazy>
                        </template>
                        <template slot="spot" slot-scope="row" >
                            <p v-if="!$helpers.isBlank(row.item.spotId)  && !$helpers.isBlank(spotMap[row.item.spotId])" >{{spotMap[row.item.spotId].name}}</p>
                        </template>
                        <template slot="type" slot-scope="row" >
                            <p v-if="!$helpers.isBlank(row.item.typeId)  && !$helpers.isBlank(employeeTypeMap[row.item.typeId])" >{{employeeTypeMap[row.item.typeId].name}}</p>
                        </template>
                        <template slot="rules" slot-scope="row" >
                            <p v-if="!$helpers.isBlank(row.item.ruleId)  && !$helpers.isBlank(employeeRulesMap[row.item.ruleId])" >{{employeeRulesMap[row.item.ruleId].name}}</p>
                        </template>
                        <template slot="accountLinked" slot-scope="row">
                            {{!$helpers.isBlank(row.item.accountId)}}
                        </template>
                       

                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openLinkModal(row)"><i class="fas fa-link"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button v-if="!row.item.active" class="mx-1" size="sm" variant="success" v-on:click="openActivateModal(row)"><i class="fas fa-user-check"></i></b-button>
                            <b-button v-if="row.item.active" class="mx-1" size="sm" variant="warning" v-on:click="openDeactivateModal(row)"><i class="fas fa-user-times"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    <b-modal ref="modal-createemployee"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="1. Mitarbeiter anlegen" @cancel="hideModal('modal-createemployee')" @ok="createEmployee" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Stamm-Position" label-for="cegfield1">
                    <b-form-select id = "cegfield1" v-model="newEmployee.spotId">
                        <option v-bind:key ="1" v-bind:value="null">
                            Keine Stammposition
                        </option>
                        <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group> 

                <b-form-group label-cols="4" label-cols-lg="2" label="Profilbild" label-for="cefield0">
                    <b-form-file id = "cefield0" accept="image/jpeg, image/png" placeholder="Profilbild auswählen..." v-model="employeePicture" ref="file-input" class="mb-2"></b-form-file>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Anrede" label-for="cefield1">
                    <b-form-select id = "cefield1" v-model="newEmployee.title">
                        <option></option>
                        <option>Herr</option>
                        <option>Frau</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Titel" label-for="cefield2">
                    <b-form-input id="cefield2" v-model="newEmployee.prefix"></b-form-input>
                </b-form-group>
           
                <b-form-group label-cols="4" label-cols-lg="2" label="Vorname" label-for="cefield3">
                    <b-form-input id="cefield3" v-model="newEmployee.firstName"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Mädchenname" label-for="cefield4">
                    <b-form-input id="cefield4" v-model="newEmployee.maidenName"></b-form-input>
                </b-form-group>

                 <b-form-group label-cols="4" label-cols-lg="2" label="Nachname" label-for="cefield5">
                    <b-form-input id="cefield5" v-model="newEmployee.lastName"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Titel 2" label-for="cefield6">
                    <b-form-input id="cefield6" v-model="newEmployee.postfix"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Geburtsdatum" label-for="cefield7">
                    <b-form-input id="cefield7" v-model="newEmployee.dob" type="date"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Religion" label-for="cefield8">
                    <b-form-input id="cefield8" v-model="newEmployee.religion"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Gender" label-for="cefield9">
                    <b-form-select id = "cefield9" v-model="newEmployee.gender">
                        <option>M</option>
                        <option>F</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="50 % Behinderung" label-for="cefield10">
                    <b-form-checkbox id="cefiedl10" v-model="newEmployee.disability">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Führerschein" label-for="cefield11">
                    <b-form-checkbox id="cefiedl11" v-model="newEmployee.driverslicense">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Führerschein Ablaufdatum" label-for="cefield12">
                    <b-form-input id="cefield12" v-model="newEmployee.dlExpiry" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Erste Hilfe Kurs" label-for="cefield13">
                    <b-form-checkbox id="cefiedl13" v-model="newEmployee.firstaidcourse">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Erste Hilfe Kurs Ablaufdatum" label-for="cefield14">
                    <b-form-input id="cefield14" v-model="newEmployee.faExpiry" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Email" label-for="cefield15">
                    <b-form-input id ="cefield15" v-model="newEmployee.email" type="email"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Heim-Telefon" label-for="cefield16">
                    <b-form-input id = "cefield16" v-model="newEmployee.homephone" type="tel"></b-form-input>
                </b-form-group>

                 <b-form-group label-cols="4" label-cols-lg="2" label="Mobil-Telefon" label-for="cefield17">
                    <b-form-input id = "cefield17" v-model="newEmployee.mobilephone" type="tel"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Adresse" label-for="cefield18">
                    <b-form-input id="cefield18" v-model="newEmployee.address"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="PLZ" label-for="cefield19">
                    <b-form-input id="cefield19" v-model="newEmployee.postalCode"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Stadt" label-for="cefield20">
                    <b-form-input id="cefield20" v-model="newEmployee.city"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Land" label-for="cefield21">
                    <b-form-select id = "cefield21" v-model.number="newEmployee.country">
                        <option v-for="item in uiData.countries" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="SV - Nummer" label-for="cefield22">
                    <b-form-input id="cefield22" v-model="newEmployee.socialsecurity"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="IBAN" label-for="cefield23">
                    <b-form-input id="cefield23" v-model="newEmployee.iban"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="BIC" label-for="cefield24">
                    <b-form-input id="cefield24" v-model="newEmployee.bic"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Nationalität" label-for="cefield25">
                    <b-form-select id = "cefield25" v-model.number="newEmployee.nationality">
                        <option v-for="item in uiData.countries" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Bürger-Typ" label-for="cefield26">
                    <b-form-select id = "cefield26" v-model.number="newEmployee.citizenType">
                        <option v-for="item in uiData.citizenTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

               

                <b-form-group   label-cols="4" label-cols-lg="2" label="Vormund Name" label-for="cefield29">
                    <b-form-input id="cefield28" v-model="newEmployee.guardianName"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Vormund Adresse" label-for="cefield30">
                    <b-form-input id="cefield29" v-model="newEmployee.guardianAdress"></b-form-input>
                </b-form-group>
            </div>
           
            <b-row v-if="employeeerror">
                Fehler beim Erstellen des Employees.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-editemployee"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Employee bearbeiten" @cancel="hideModal('modal-editemployee')" @ok="editEmployee" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="2" label="Profilbild" label-for="uefield0">
                    <b-form-file id = "uefield0" accept="image/jpeg, image/png" placeholder="Profilbild auswählen..." v-model="employeePicture" ref="file-input" class="mb-2"></b-form-file>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Plan Typ" label-for="cegfielda">
                    <b-form-select id = "cegfielda" v-model="newEmployee.typeId">
                        <option v-bind:key ="1" v-bind:value="null">
                            Kein Plantyp
                        </option>
                         <option v-for="option in employeeTypeMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Plan Optionen" label-for="cegfield0">
                    <b-form-select id = "cegfield0" v-model="newEmployee.ruleId">
                        <option v-bind:key ="1" v-bind:value="null">
                            Keine Plan Optionen
                        </option>
                         <option v-for="option in employeeRulesMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Stamm-Position" label-for="cgfield0">
                    <b-form-select id = "cgfield0" v-model="newEmployee.spotId">
                        <option v-bind:key ="1" v-bind:value="null">
                            Keine Stammposition
                        </option>
                        <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Vorname" label-for="newfirstn">
                    <b-form-input id="newfirstn" v-model="newEmployee.firstName"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Nachname" label-for="newlastn">
                    <b-form-input id="newlastn" v-model="newEmployee.lastName"></b-form-input>
                </b-form-group>
            </div>
          
            <b-row v-if="employeeerror">
                Fehler beim Bearbeiten des Mitarbeiters.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-deleteemployee"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter löschen" @cancel="hideModal('modal-deleteemployee')" @ok="deleteEmployee" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Mitarbeiter {{newEmployee.firstName}} {{newEmployee.lastName}} löschen wollen?</p>
            </b-row>
            <b-row v-if="employeeerror">
                Fehler beim Löschen des Employees.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-linkemployee"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Account registrieren" @cancel="hideModal('modal-linkemployee')" @ok="linkEmployee" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Mitarbeiter {{newEmployee.firstName}} {{newEmployee.lastName}} bei Mein Dienstplan registrieren wollen?</p>
            </b-row>
            <b-row v-if="employeeerror">
                Fehler beim Registrieren.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deactivateemployee"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter deaktivieren" @cancel="hideModal('modal-deactivateemployee')" @ok="deactivateEmployee" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Mitarbeiter {{newEmployee.firstName}} {{newEmployee.lastName}} deaktivieren wollen?</p>
            </b-row>
            <b-form-group label-cols="4" label-cols-lg="2" label="Austrittsdatum" label-for="cs3">
                <b-form-input id="cs3" v-model="deactivationDate.date" type="date"></b-form-input>
            </b-form-group>

            <b-form-group label-cols="4" label-cols-lg="2" label="Austrittsuhrzeit" label-for="cs4">
                <b-form-input id="cs4" v-model="deactivationDate.time" type="time"></b-form-input>
            </b-form-group>
            <b-row v-if="employeeerror">
                Fehler beim Deaktivieren.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-activateemployee"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter aktivieren" @cancel="hideModal('modal-activateemployee')" @ok="activateEmployee" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Mitarbeiter {{newEmployee.firstName}} {{newEmployee.lastName}} aktivieren wollen?</p>
            </b-row>
            <b-row v-if="employeeerror">
                Fehler beim Aktivieren.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-createemployeecontract"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Arbeitsvertrag anlegen" @cancel="hideModal('modal-createemployeecontract')" @ok="createEmployeeContract" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Beruf" label-for="ccfield1">
                    <b-form-input id="ccfield1" v-model="employeeContract.jobName"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left" label-cols="4" label-cols-lg="4" label="Art der Anstellung" label-for="ccfield2">
                    <b-form-select id = "ccfield2" v-model.number="employeeContract.employmentType">
                        <option v-for="item in uiData.employmentTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Lehrjahr" label-for="ccfield3" v-if="employeeContract.employmentType === 3">
                    <b-form-input  min="1" id="ccfield3" v-model.number="employeeContract.apprenticeYear" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Anstellungs Kategorie" label-for="ccfield4">
                    <b-form-select id = "ccfield4" v-model.number="employeeContract.employeeCategory">
                        <option v-for="item in uiData.employeeCategories" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Vertrags-Typ" label-for="ccfield5">
                    <b-form-select id = "ccfield5" v-model.number="employeeContract.contractType">
                        <option v-for="item in uiData.contractTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Zahlungs-Typ" label-for="ccfield6">
                    <b-form-select id = "ccfield6" v-model.number="employeeContract.paymentType">
                        <option v-for="item in uiData.paymentTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Zahlung" label-for="ccfield7">
                    <b-form-input  min="0" id="ccfield7" v-model.number="employeeContract.payment" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Nachtarbeiter-Typ" label-for="ccfield8">
                    <b-form-select id = "ccfield8" v-model.number="employeeContract.nightWorkerType">
                        <option v-for="item in uiData.nightWorkerTypes" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Nachtarbeit Stunden Bonus" label-for="ccfield9">
                    <b-form-input  min="0" id="ccfield9" v-model.number="employeeContract.nightWorkBonusHour" type="number"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Nachtarbeit Pauschal Bonus" label-for="ccfield10">
                    <b-form-input  min="0" id="ccfield10" v-model.number="employeeContract.nightWorkBonusShift" type="number"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Mehrarbeit Stunden Bonus" label-for="ccfield11">
                    <b-form-input  min="0" id="ccfield11" v-model.number="employeeContract.overtimeBonusHour" type="number"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Mehrarbeit Pauschal Bonus" label-for="ccfield12">
                    <b-form-input  min="0" id="ccfield12" v-model.number="employeeContract.overtimeBonusShift" type="number"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Urlaubstage" label-for="ccfield13">
                    <b-form-input  min="0" id="ccfield13" v-model.number="employeeContract.vacationTime" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Von" label-for="ccfield14">
                    <b-form-input id="ccfield14" v-model="employeeContract.from" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Bis" label-for="ccfield15">
                    <b-form-input id="ccfield15" v-model="employeeContract.to" type="date"></b-form-input>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Probezeit bis" label-for="ccfield16">
                    <b-form-input id="ccfield16" v-model="employeeContract.probationTo" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Stunden" label-for="ccfield17">
                    <b-form-input  min="0" max="168" id="ccfield17" v-model.number="employeeContract.weekTimeRegular" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochen Soll-Arbeitstage" label-for="ccfield18">
                    <b-form-input  min="1" max="7" id="ccfield18" v-model.number="employeeContract.weekWorkDaysRegular" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Kostenstelle" label-for="ccfield19">
                    <b-form-input  id="ccfield19" v-model.number="employeeContract.costCenter" ></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Kollektiv Vertrag" label-for="ccfield20">
                     <b-form-checkbox id="ccfield20" v-model="employeeContract.collectiveContract">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Kollektiv Vertrag Typ" label-for="ccfield21" v-if="employeeContract.collectiveContract">
                    <b-form-input id="ccfield21" v-model="employeeContract.collectiveContractType"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Kollektiv Vertrag Lohnstufe" label-for="ccfield22" v-if="employeeContract.collectiveContract">
                    <b-form-input min ="1" id="ccfield22" v-model.number="employeeContract.collectiveContractRank"></b-form-input>
                </b-form-group>

                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Kommentar" label-for="ccfield23">
                    <b-form-input id="ccfield23" v-model="employeeContract.comment"></b-form-input>
                </b-form-group>
           
                
            </div>
           
            <b-row v-if="employeeerror">
                Fehler beim Erstellen des Vertrags.
            </b-row>
        </b-container>
    </b-modal>

    

    <b-modal ref="modal-createemployeeskill"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Skill hinzufügen" @cancel="hideModal('modal-createemployeeskill')" @ok="createEmployeeSkill" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Skill" label-for="cesfield1">
                    <b-form-select id = "ccfield1" v-model="employeeSkill.skillId">
                         <option v-for="option in skillMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>


                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Wert" label-for="cesfield2">
                    <b-form-input  min="0"  max="100" id="cesfield2" v-model.number="employeeSkill.value" type="number"></b-form-input>
                </b-form-group>
                
            </div>
           
            <b-row v-if="employeeerror">
                Fehler beim Erstellen des Employees.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteemployeecontract"  no-close-on-backdrop no-close-on-esc centered title="Vertrag löschen" @cancel="hideModal('modal-deleteemployeecontract')" @ok="deleteEmployeeContract" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Vertrag löschen wollen?</p>
            </b-row>
            <b-row v-if="employeeerror">
                Fehler beim Löschen des Vertrages.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteemployeeavailability"  no-close-on-backdrop no-close-on-esc centered title="Verfügbarkeit löschen" @cancel="hideModal('modal-deleteemployeeavailability')" @ok="deleteEmployeeAvailability" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie die Verfügbarkeit löschen wollen?</p>
            </b-row>
            <b-row v-if="employeeerror">
                Fehler beim Löschen der Verfügbarkeit.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteemployeeskill"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Skill löschen" @cancel="hideModal('modal-deleteemployeeskill')" @ok="deleteEmployeeSkill" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie den Skill des Mitarbeiters löschen wollen?</p>
            </b-row>
            <b-row v-if="employeeerror">
                Fehler beim Löschen der Verfügbarkeit.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-startemployeesync"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Import" @cancel="hideModal('modal-startemployeesync')" @ok="syncWithCore" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie Mitarbeiter aus den Stammdaten importieren wollen?</p>
                <p> Der Prozess kann eine Weile dauern.</p>
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-employeesyncinfo"  no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Import" @cancel="hideModal('modal-employeesyncinfo')" @ok="hideModal('modal-employeesyncinfo')" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> {{employeeSyncInfo}}</p>
            </b-row>
        </b-container>
    </b-modal>

   <b-modal ref="modal-viewemployee"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Detail" @cancel="hideModal('modal-viewemployee')" @ok="hideModal('modal-viewemployee')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Mitarbeiter" active>
                    <div v-if="employeeMap[employeeId] != undefined">
                        <b-row v-if="employeeMap[employeeId].employeePicture != null">
                            <b-col>
                                <b-img thumbnail rounded="circle" width=150 height=150 center fluid :src="buildEmployeePictureUrl(employeeId)" alt="Image 1"></b-img>
                            </b-col>
                        </b-row>
                        <b-row>
                           
                           <b-col class="md-2">
                                <b>Stamm Position:</b> 
                            </b-col>
                            <b-col v-if="employeeMap[employeeId].spotId != null && spotMap[employeeMap[employeeId].spotId] != null">
                                {{spotMap[employeeMap[employeeId].spotId].name}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Plan Typ:</b> 
                            </b-col>
                            <b-col v-if="employeeMap[employeeId].typeId != null && employeeTypeMap[employeeMap[employeeId].typeId] != null">
                                {{employeeTypeMap[employeeMap[employeeId].typeId].name}}
                            </b-col>
                           <b-col class="md-2">
                                <b>Plan Optionen:</b> 
                            </b-col>
                            <b-col v-if="employeeMap[employeeId].ruleId != null && employeeRulesMap[employeeMap[employeeId].ruleId] != null">
                                {{employeeRulesMap[employeeMap[employeeId].ruleId].name}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Anrede:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].title}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Titel:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].prefix}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Vorname:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].firstName}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Mädchenname:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].maidenName}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Nachname:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].lastName}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Titel 2:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].postfix}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Gender:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].gender}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Religion:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].religion}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Geburtstag:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].dob}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Aktiv:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].active}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>SV-Nummer:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].socialsecurity}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Email:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].email}}
                            </b-col>
                        </b-row>
                        <b-row>
                             <b-col class="md-2">
                                <b>Heim-Tel.:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].homephone}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Mobil-Tel.:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].mobilephone}}
                            </b-col>
                        </b-row>
                        <b-row>
                             <b-col class="md-2">
                                <b>Adresse:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].address}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Stadt:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].city}}
                            </b-col>
                        </b-row>
                        <b-row>
                             <b-col class="md-2">
                                <b>PLZ:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].postalCode}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Land:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].country}}
                            </b-col>
                        </b-row>
                        <b-row>
                             <b-col class="md-2">
                                <b>Nationalität:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].nationality}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bürger - Typ:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].citizenType}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Führerschein:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].driverslicense}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Führerschein Ablaufdatum:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].dlExpiry}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Erste Hilfe Kurs:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].firstaidcourse}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Erste Hilfe Ablaufdatum:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].faExpiry}}
                            </b-col>
                        </b-row>
                        <b-row>
                             <b-col class="md-2">
                                <b>IBAN:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].iban}}
                            </b-col>
                            <b-col class="md-2">
                                <b>BIC:</b> 
                            </b-col>
                            <b-col>
                                {{employeeMap[employeeId].bic}}
                            </b-col>
                        </b-row>
                        
                    </div>
                </b-tab>
                <b-tab title="Skills">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createemployeeskill')">Skill hinzufügen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="employeeSkills!= undefined">
                        <b-table bordered :items="employeeSkills" :fields="employeeSkillsTableFields">
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteEmployeeSkillModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
                <b-tab title="Verträge">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createemployeecontract')">Vertrag erstellen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="employeeContracts != undefined">
                        <b-table bordered :items="employeeContracts" :fields="contractTableFields">
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewContractModal(row)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteContractModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
                <b-tab title="Verfügbarkeiten & Präferenzen">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createemployeeavailability')">Verfügbarkeit/Präferenz erstellen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="employeeAvailabilities!= undefined">
                        <b-table bordered :items="employeeAvailabilities" :fields="availabilityTableFields">
                            <template slot="stateLabel" slot-scope="row">
                                <p v-if="employeeAvailabilityStateMap[row.item.state] != null"> {{employeeAvailabilityStateMap[row.item.state].label_de}}</p>
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button class="mx-1" size="sm"><i class="fas fa-pencil-alt"></i></b-button>
                                <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteAvailabilityModal(row)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
                <b-tab title="Dateien" v-if ="employeeId != null">
                    <employeefiles :employeeId = employeeId></employeefiles>
                       
                    
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createemployeeavailability"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Verfügbarkeit anlegen" @cancel="hideModal('modal-createemployeeavailability')" @ok="createEmployeeAvailability" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Status" label-for="availabilitystate">
                    <b-form-select id = "availabilitystate" v-model="employeeAvailability.state">
                        <option v-for="item in uiData.employeeAvailabilityStates" v-bind:key ="item.id" v-bind:value="item.id">
                            {{ item.label_de }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Wichtigkeit" label-for="ce9" v-if="employeeAvailability.type ==='DESIRED' || employeeAvailability.type ==='UNDESIRED'">
                    <b-form-input id="ce9" min=1 max=10 v-model.number="employeeAvailability.factor" type="number"></b-form-input>
                </b-form-group>
                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Begrenzung Position" label-for="availabilitySpot">
                    <b-form-select id = "availabilitySpot" v-model="employeeAvailability.spotId">
                        <option v-bind:value="null">
                            Keine Begrenzung
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Von" label-for="availabilityFrom">
                    <b-form-input id="availabilityFrom" v-model="employeeAvailability.from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Bis" label-for="availabilityTo">
                    <b-form-input id="availabilityTo" v-model="employeeAvailability.to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Montag" label-for="mondaycheck">
                     <b-form-checkbox id="mondaycheck" v-model="employeeAvailability.monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Dienstag" label-for="tuesdaycheck">
                     <b-form-checkbox id="tuesdaycheck" v-model="employeeAvailability.tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mittwoch" label-for="wednesdaycheck">
                     <b-form-checkbox id="wednesdaycheck" v-model="employeeAvailability.wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Donnerstag" label-for="thursdaycheck">
                     <b-form-checkbox id="thursdaycheck" v-model="employeeAvailability.thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freitag" label-for="fridaycheck">
                     <b-form-checkbox id="fridaycheck" v-model="employeeAvailability.friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Samstag" label-for="saturdaycheck">
                     <b-form-checkbox id="saturdaycheck" v-model="employeeAvailability.saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Sonntag" label-for="sundaycheck">
                     <b-form-checkbox id="sundaycheck" v-model="employeeAvailability.sunday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Kommentar" label-for="ca8">
                    <b-form-input id="ca8" v-model="employeeAvailability.comment" type="text"></b-form-input>
                </b-form-group>
                
            </div>
           
            <b-row v-if="employeeerror">
                Fehler beim Erstellen des Employees.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewcontract"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Vertrag Detail" @cancel="hideModal('modal-viewcontract')" @ok="hideModal('modal-viewcontract')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Vertrag" active>
                    <div v-if="employeeContractMap[contractId] != undefined && employeeContractMap[contractId]!= undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Beruf:</b>
                            </b-col>
                            <b-col>
                                {{employeeContractMap[contractId].jobName}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Art der Anstellung:</b>
                            </b-col>
                            <b-col>
                               {{employeeContractMap[contractId].employmentType}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Anstellungs Kategorie:</b>
                            </b-col>
                            <b-col>
                                {{employeeContractMap[contractId].employeeCategory}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Vertragstyp:</b>
                            </b-col>
                            <b-col>
                               {{employeeContractMap[contractId].contractType}}
                            </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col class="md-2">
                                <b>Zahlungs-Typ:</b>
                            </b-col>
                            <b-col>
                                {{employeeContractMap[contractId].paymentType}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Vertrags-Gehalt:</b>
                            </b-col>
                            <b-col>
                               {{employeeContractMap[contractId].payment}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b>
                            </b-col>
                            <b-col>
                                {{employeeContractMap[contractId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b>
                            </b-col>
                            <b-col>
                               {{employeeContractMap[contractId].to}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Wochentag-Soll:</b>
                            </b-col>
                            <b-col>
                                {{employeeContractMap[contractId].weekWorkDaysRegular}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Wochen-Soll:</b>
                            </b-col>
                            <b-col>
                               {{employeeContractMap[contractId].weekTimeRegular/60}}
                            </b-col>
                        </b-row>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>
  </div> 

</template>

<script>
import employeefiles from './EmployeeFiles'
export default {
  name: 'employeeoverview',
  props: ["storeId"],
  components: {
      employeefiles,
  },
  data () {
    return {
      employees: [],
      employeeMap:{},
      spotMap:{},
      employeeContracts:[],
      employeeContractMap: {},
      employeeAvailabilities:[],
      employeeAvailabilityMap: {},
      employeeAvailabilityStateMap: {},
      skillMap:{},
      employeeSkills:[],
      employeeSkillMap: {},
      employeeTypeMap: {},
      employeeRulesMap: {},

      employeePicture: null,
      fields: [{key:"employeePicture", label:"", thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"firstName", label:"Vorname", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"lastName", label:"Nachname", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key:"spot", label:"Stamm Position", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"type", label:"Plan Typ", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"rules", label:"Plan Optionen", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key:"accountLinked", label:"Account", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"active", label:"Aktiv", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
               {key:"actions", label:"", sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'}],
      contractTableFields: [{key:"paymentType", label:"Anstellungs-Typ", sortable: true}, {key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true}, {key:"actions", sortable: false}],
      availabilityTableFields: [{key:"stateLabel", label:"Verfügbarkeits-Status", sortable: true}, {key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true}, {key:"weekDays", label:"Wochentage", sortable: false}, {key:"actions", sortable: false}],
      employeeSkillsTableFields: [{key:"name", label:"Name", sortable: true}, {key:"value", label:"Wert", sortable: true}, {key:"actions", sortable: false}],
      
      uiData: {},
      employeename: "",
      employeeId:null,
      contractId:"",
      availabilityId:"",
      employeeSkillId: "",
      employeeTypeId: undefined,
      employeeRulesId: undefined,
      newEmployee: {
          spotId: null,
          typeId: null,
          ruleId: null,
          title: "Herr",
          prefix: "",
          firstName: "",
          postfix: "",
          lastName: "",
          dob: null,
          gender: "M",
          religion: "",
          socialsecurity: "",
          disability: false,
          driverslicense: false,
          dlExpiry: null,
          firstaidcourse: false,
          faExpiry: null,
          mobilephone:"",
          homephone: "",
          email: "",
          country: 1,
          address: "",
          postalCode: "",
          city: "",
          iban: "",
          bic: "",
          nationality: 1,
          citizenType: 1,
          guardianName: "",
          guardianAddress: "" 
      },
      employeeSkill: {
          skillId: "",
          value: 0
      },
      employeeContract: {
          jobName: "",
          from: null,
          to: null,
          probationTo: null,
          paymentType: 1,
          payment: 2000,
          weekTimeRegular: 40,
          weekWorkDaysRegular: 5,
          vacationTime: 0,
          employeeCategory: 1,
          employmentType: 1,
          contractType: 1,
          nightWorkerType: 1,
          nightWorkBonusHour: 0,
          nightWorkBonusShift: 0,
          overtimeBonusHour: 0,
          overtimeBonusShift: 0,
          costCenter: "",
          collectiveContract: false,
          collectiveContractType: "",
          collectiveContractRank: 0,
          apprenticeYear: 1,
          comment: ""
      },
      employeeAvailability: {
          from: "",
          to: "",
          spotId: null,
          state: 1,
          factor: 1,
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          comment: null,

      },
      deactivationDate: {
          date: null,
          time: null,
      },
      employeeSyncInfo: "",
      currentEmployeeRow: {},
      currentContractRow:{},
      currentAvailabilityRow:{},
      currentEmployeeSkillRow: {},
      employeeerror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;

        this.loadUIData()
        .then(response=> {
            view.updateUIData(response.data);
            return view.loadSpots();
        }).then(response => {
            view.updateSpots(response.data);
            return view.loadSkills();
        }).then(response => {
            view.updateSkills(response.data);
            return view.loadEmployeeSkills();
        }).then(response => {
            view.updateEmployeeSkills(response.data);
            return view.loadEmployeeContracts();
        }).then(response => {
            view.updateEmployeeContratcts(response.data);
            return view.loadEmployeeAvailabilities();
        }).then(response => {
            view.updateEmployeeAvailabilities(response.data);
            return view.loadEmployeeTypes();
        }).then(response => {
            view.updateEmployeeTypes(response.data);
            return view.loadEmployeeRules();
        }).then(response => {
            view.updateEmployeeRules(response.data);
            return view.loadTableData();
        }).then(response => {
            view.setOverview(response.data); 
        }).catch(function (error) {
            console.log(error)
        })     
    }, 
    createEmployee: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employee');
        
        let payload = {
          storeId: this.$store.state.storeId,
        }
        
        for (var property in this.newEmployee) {
            if(!this.$helpers.isBlank(this.newEmployee[property])){
                payload[property] = this.newEmployee[property];
            } else {
                payload[property] = null;
            }
            
        }
        payload.dob = this.$helpers.convertDateTimeString(this.newEmployee.dob);
        payload.dlExpiry = this.$helpers.convertDateTimeString(this.newEmployee.dlExpiry);
        payload.faExpiry = this.$helpers.convertDateTimeString(this.newEmployee.faExpiry);
       

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            let employee = response.data.data;
            view.employeeMap[employee.id] = employee;
            view.employees.push(employee);
            if(view.employeePicture != null){
                //set employee picture
                this.setEmployeePicture(employee.id)
                .then(response2=>{
                    employee.employeePicture = response2.data.data;
                    view.employeePicture = null;
                    
                    if(view.newEmployee.spotId != null){
                        view.linkSpot(employee.id, view.newEmployee.spotId, true, 10, employee);
                    }
                   
                    view.hideModal('modal-createemployee');
                    view.openViewModal(employee.id);
                }).catch(error2 => {
                    view.employeePicture = null;
                    console.log(error2);
                    view.hideModal('modal-createemployee');
                    view.openViewModal(employee.id);
                })
            } else {
                if(view.newEmployee.spotId != null){
                    view.linkSpot(employee.id, view.newEmployee.spotId, true, 10, employee);
                }
                view.hideModal('modal-createemployee');
                view.openViewModal(employee.id);
            }
            
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    setEmployeePicture: function(employeeId){
        let view = this;
        let url = '/api/sec/employee/picture';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/picture');
        let formData = new FormData();
        formData.append("employeeId", employeeId);
        formData.append('file', this.employeePicture);

        return this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt,
                'Content-Type': 'multipart/form-data'
            },
            url: url,
            data: formData
        }).catch(error => 
            Promise.reject({msg: "Fehler beim Setzen des Profilbildes"})
        )
    },
    buildEmployeePictureUrl(employeeId){
        if(this.employeeMap[employeeId].employeePicture != null){
            let picture = this.employeeMap[employeeId].employeePicture
            return picture.server+"/api/file?id="+picture.fileId+"&accessToken="+picture.accessToken+"&thumb=small";
        } else {
            return "../img/default.jpg";
        }
        
    },
    syncWithCore: function(evt){
        
        
        let view = this;
        let url = '/api/sec/employeesync';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeesync');
        
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.employeeSyncInfo = "Stammdaten Import erfolgreich gestartet"
            view.showModal("modal-employeesyncinfo")
        }).catch(function (error) {
            view.employeeSyncInfo = "Stammdaten Import konnte nicht durchgeführt werden. Möglicherweise ist ein Import bereits im Gange."
            view.showModal("modal-employeesyncinfo");
        })

    },
    createEmployeeSkill: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employeeskill';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill');
        let payload = {
          storeId: this.$store.state.storeId,
          employeeId: this.employeeId,
        }

        payload.skillId = this.employeeSkill.skillId;
        payload.value = this.employeeSkill.value;
       
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
           
            
            view.employeeSkillMap[response.data.data.id] = response.data.data;
            let employeeSkillEntry ={
                id: response.data.data.id,
                value: response.data.data.value,
                name: view.skillMap[response.data.data.skillId].name
            }
            view.employeeSkills.push(employeeSkillEntry);
            view.hideModal('modal-createemployeeskill');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    createEmployeeContract: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employeecontract';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');

        let payload = {
          storeId: this.$store.state.storeId,
          employeeId: this.employeeId,
        }
        if(!this.$helpers.isBlank(this.employeeContract.jobName)){
              payload.jobName = this.employeeContract.jobName;
        }
        payload.from = this.$helpers.convertDateTimeString(this.employeeContract.from);
        payload.to = this.$helpers.convertDateTimeString(this.employeeContract.to);
        payload.probationTo = this.$helpers.convertDateTimeString(this.employeeContract.probationTo);
        payload.paymentType = this.employeeContract.paymentType;
        payload.payment = this.employeeContract.payment;
        payload.weekTimeRegular = this.employeeContract.weekTimeRegular*60;
        payload.weekWorkDaysRegular = this.employeeContract.weekWorkDaysRegular;
        payload.vacationTime = this.employeeContract.vacationTime*24*60;
        payload.employeeCategory = this.employeeContract.employeeCategory;
        payload.employmentType = this.employeeContract.employmentType;
        payload.contractType = this.employeeContract.contractType;
        payload.nightWorkerType = this.employeeContract.nightWorkerType;
        payload.nightWorkBonusHour = this.employeeContract.nightWorkBonusHour;
        payload.nightWorkBonusShift = this.employeeContract.nightWorkBonusShift;
        payload.overtimeBonusHour = this.employeeContract.overtimeBonusHour;
        payload.overtimeBonusShift = this.employeeContract.overtimeBonusShift;
        if(!this.$helpers.isBlank(this.employeeContract.comment)){
             payload.comment = this.employeeContract.comment;
        }
        let specificData = {};
        if(!this.$helpers.isBlank(this.employeeContract.costCenter)){
            specificData.costCenter = this.employeeContract.costCenter;
        }
        
        if(this.employeeContract.collectiveContract){
            specificData.collectiveContract = this.employeeContract.collectiveContract;
            specificData.collectiveContractType = this.employeeContract.collectiveContractType;
            specificData.collectiveContractRank = this.employeeContract.collectiveContractRank;
        }
        if(this.employeeContract.employmentType === 3){
            specificData.apprenticeYear = this.employeeContract.apprenticeYear;
        }
        payload.specificData = specificData;
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            
            view.employeeContractMap[response.data.data.id] = response.data.data;
            view.contractId = response.data.data.id;
            view.employeeContracts.push(response.data.data);
            view.hideModal('modal-createemployeecontract');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    createEmployeeAvailability: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employeeavailability';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability');
        let payload = {
          storeId: this.$store.state.storeId,
          employeeId: this.employeeId,
        }

        payload.state = this.employeeAvailability.state;
        payload.from = this.$helpers.convertDateTimeString(null,this.employeeAvailability.from);
        payload.to = this.$helpers.convertDateTimeString(null,this.employeeAvailability.to);
        payload.factor = this.employeeAvailability.factor;
        payload.spotId = this.employeeAvailability.spotId;
        payload.comment = this.employeeAvailability.comment;
        payload.exclusive=true;
        payload.weekDays = [];
        if(this.employeeAvailability.monday){
            payload.weekDays.push(1);
        }
        if(this.employeeAvailability.tuesday){
            payload.weekDays.push(2);
        }
        if(this.employeeAvailability.wednesday){
            payload.weekDays.push(3);
        }
        if(this.employeeAvailability.thursday){
            payload.weekDays.push(4);
        }
        if(this.employeeAvailability.friday){
            payload.weekDays.push(5);
        }
        if(this.employeeAvailability.saturday){
            payload.weekDays.push(6);
        }
        if(this.employeeAvailability.sunday){
            payload.weekDays.push(7);
        }
        
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
           
            view.employeeAvailabilityMap[response.data.data.id] = response.data.data;
            view.availabilityId = response.data.data.id;
            view.employeeAvailabilities.push(response.data.data);
            
            view.hideModal('modal-createemployeeavailability');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    openEditModal: function(row){
        this.currentEmployeeRow = row;
        this.newEmployee.firstName = row.item.firstName;
        this.newEmployee.lastName = row.item.lastName;
        this.newEmployee.typeId = row.item.typeId;
        this.newEmployee.ruleId = row.item.ruleId;
        this.newEmployee.spotId = row.item.spotId;
        this.employeeId = row.item.id;
        this.showModal('modal-editemployee');
    },
    editEmployee: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
        
        let payload = {
          id: this.employeeId,
          updateFields:["firstName", "lastName", "typeId", "ruleId"],
          typeId: this.newEmployee.typeId,
          ruleId: this.newEmployee.ruleId,
          firstName: this.newEmployee.firstName,
          lastName: this.newEmployee.lastName,

        }
        console.log(payload);
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.currentEmployeeRow.item.firstName = view.newEmployee.firstName;
            view.currentEmployeeRow.item.lastName = view.newEmployee.lastName;
            view.currentEmployeeRow.item.typeId = view.newEmployee.typeId;
            view.currentEmployeeRow.item.ruleId = view.newEmployee.ruleId;
            if(view.employeeMap[view.employeeId] != undefined){
                view.employeeMap[view.employeeId].firstName = view.newEmployee.firstName;
                view.employeeMap[view.employeeId].lastName = view.newEmployee.lastName;
                view.employeeMap[view.employeeId].typeId = view.newEmployee.typeId;
                view.employeeMap[view.employeeId].ruleId = view.newEmployee.ruleId;
            }
            if(view.employeePicture != null){
                //set employee picture
                this.setEmployeePicture(view.employeeId)
                .then(response2=>{
                    if(view.employeeMap[view.employeeId] != undefined){
                        view.employeeMap[view.employeeId].employeePicture = response2.data.data;
                    }
                    view.employeePicture = null;
                    view.linkSpot(view.employeeId, view.newEmployee.spotId, true, 10, view.currentEmployeeRow.item);
                    view.hideModal('modal-editemployee');
                }).catch(error2 => {
                    view.employeePicture = null;
                    console.log(error2);
                    view.hideModal('modal-editemployee');
                })
            } else {
                view.linkSpot(view.employeeId, view.newEmployee.spotId, true, 10, view.currentEmployeeRow.item);
                view.hideModal('modal-editemployee');
            }
            
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    openLinkModal: function(row){
        this.currentEmployeeRow = row;
        this.newEmployee.firstName = row.item.firstName;
        this.newEmployee.lastName = row.item.lastName;
        this.employeeId = row.item.id;
        this.showModal('modal-linkemployee');
    },
    linkEmployee: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee/linkaccount';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkaccount');
        url = this.$helpers.appendParam("id", this.employeeId, url, '/api/sec/employee/linkaccount');

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.currentEmployeeRow.item.accountId=response.data.data;
            
            view.hideModal('modal-linkemployee');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    openDeactivateModal: function(row){
        this.currentEmployeeRow = row;
        this.newEmployee.firstName = row.item.firstName;
        this.newEmployee.lastName = row.item.lastName;
        this.employeeId = row.item.id;
        this.showModal('modal-deactivateemployee');
    },
    deactivateEmployee: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee/deactivate';
       
        let datestring = this.$helpers.convertDateTimeString(this.deactivationDate.date, this.deactivationDate.time);
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/deactivate');
        url = this.$helpers.appendParam("id", this.employeeId, url, '/api/sec/employee/deactivate');
        url = this.$helpers.appendParam("exitDate", datestring, url, '/api/sec/employee/deactivate');

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.currentEmployeeRow.item.active=false;
            view.employeeMap[view.employeeId].active = false; 
            view.hideModal('modal-deactivateemployee');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    openActivateModal: function(row){
        this.currentEmployeeRow = row;
        this.newEmployee.firstName = row.item.firstName;
        this.newEmployee.lastName = row.item.lastName;
        this.employeeId = row.item.id;
        this.showModal('modal-activateemployee');
    },
    activateEmployee: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee/activate';
       
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/activate');
        url = this.$helpers.appendParam("id", this.employeeId, url, '/api/sec/employee/activate');
        

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.currentEmployeeRow.item.active=true;
            
            view.employeeMap[view.employeeId].active = true;
            
            view.hideModal('modal-activateemployee');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    linkSpot: function(id, spotId, deleteOldSkill, skillValue, toUpdate){
       
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee/linkspot';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkspot');
        let payload =  {
            id: id,
            spotId: spotId,
            deleteOldSkill: deleteOldSkill,
            skillValue: skillValue,
        }

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            toUpdate.spotId = spotId;
            if(view.employeeMap[id] != undefined){
                view.employeeMap[id].spotId = spotId;
            }
            view.loadEmployeeSkills()
            .then(response => {
                view.updateEmployeeSkills(response.data);
            }).catch(function (error) {
                console.log(error)
            })
        }).catch(function (error) {
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentEmployeeRow = row;
        this.newEmployee.firstName = row.item.firstName;
        this.newEmployee.lastName = row.item.lastName;
        this.employeeId = row.item.id;
        this.showModal('modal-deleteemployee');
    },
    openDeleteContractModal: function(row){
        this.currentContractRow = row;
        this.contractId = row.item.id;
        this.showModal('modal-deleteemployeecontract');
    },
    openDeleteAvailabilityModal: function(row){
        this.currentAvailabilityRow= row;
        this.availabilityId = row.item.id;
        this.showModal('modal-deleteemployeeavailability');
    },
    openDeleteEmployeeSkillModal : function(row) {
        this.currentEmployeeSkillRow = row;
        this.employeeSkillId = row.item.id;
        this.showModal('modal-deleteemployeeskill');
    },
    deleteEmployeeSkill: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employeeskill';
        
        url = this.$helpers.appendParam("id", this.employeeSkillId, url, '/api/sec/employeeskill');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill');
       
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.employeeSkills.findIndex(employeeSkill => employeeSkill.id === view.employeeSkillId) 
            if (~index) {
                view.employeeSkills.splice(index, 1);
            } 
            view.deleteEmployeeSkillFromMap(view.employeeSkillId);
            
            view.hideModal('modal-deleteemployeeskill');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    deleteEmployeeContract: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employeecontract';
        
        url = this.$helpers.appendParam("id", this.contractId, url, '/api/sec/employeecontract');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.employeeContracts.findIndex(contract => contract.id === view.contractId) // find the employee index 
            if (~index) {
                view.employeeContracts.splice(index, 1);
            } 
            view.deleteContractFromMap(view.contractId);
            
            view.hideModal('modal-deleteemployeecontract');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    deleteEmployee: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employee';
        
        url = this.$helpers.appendParam("id", this.employeeId, url, '/api/sec/employee');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
           
            const index = this.employees.findIndex(employee => employee.id === view.employeeId) // find the employee index 
            if (~index) {
                 view.employees.splice(index, 1);
            } 
            view.deleteEmployeeFromMap(view.employeeId);
            
            view.hideModal('modal-deleteemployee');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    deleteEmployeeAvailability: function(evt){
        evt.preventDefault();
        this.employeeerror=false;
        let view = this;
        let url = '/api/sec/employeeavailability';
        
        url = this.$helpers.appendParam("id", this.availabilityId, url, '/api/sec/employeeavailability');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability');
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = view.employeeAvailabilities.findIndex(availability => availability.id === view.availabilityId) // find the employee index 
            if (~index) {
                view.employeeAvailabilities.splice(index, 1);
            } 
            view.deleteAvailabilityFromMap(view.availabilityId);
            
            view.hideModal('modal-deleteemployeeavailability');
        }).catch(function (error) {
            view.employeeerror=true;
            console.log(error)
        })

    },
    deleteEmployeeFromMap(id){
        for(var property in this.employeeContractMap){
            if(this.employeeContractMap[property].employeeId === id){
                 this.deleteContractFromMap(property);
            }
        }
        for(var p in this.employeeAvailabilityMap){
            if(this.employeeAvailabilityMap[p].employeeId === id){
                this.deleteAvailabilityFromMap(p);
            }
        }
        for(var p2 in this.employeeSkillMap){
            if(this.employeeSkillMap[p2].employeeId === id){
                this.deleteEmployeeSkillFromMap(p2);
            }
        }
        delete this.employeeMap[id];
    },
    deleteContractFromMap(id){
        delete this.employeeContractMap[id];
    },
    deleteAvailabilityFromMap(id){
        delete this.employeeAvailabilityMap[id]
    },
    deleteEmployeeSkillFromMap(id){
        delete this.employeeSkillMap[id]
    },
    openViewModal: function(id){
        let view = this;
        this.employeeId = id;
        this.employeeContracts = [];
        for(var property in this.employeeContractMap){
            if(this.employeeContractMap[property].employeeId === this.employeeId){
                this.employeeContracts.push(this.employeeContractMap[property]);
            }
        }
        this.employeeAvailabilities = [];
        for(var p in this.employeeAvailabilityMap){
            if(this.employeeAvailabilityMap[p].employeeId === this.employeeId){
                this.employeeAvailabilities.push(this.employeeAvailabilityMap[p]);
            }
        }
        this.employeeSkills = [];
        for(var p2 in this.employeeSkillMap){
            if(this.employeeSkillMap[p2].employeeId === this.employeeId){
                let employeeSkillEntry ={
                    id: this.employeeSkillMap[p2].id,
                    value: this.employeeSkillMap[p2].value,
                    name: this.skillMap[this.employeeSkillMap[p2].skillId].name
                }
                this.employeeSkills.push(employeeSkillEntry);
            }
        }
        view.showModal('modal-viewemployee');
    },
    openViewContractModal: function(row){
        let view = this;
        this.currentContractRow = row;
        this.contractId = row.item.id;
       
        view.showModal('modal-viewcontract');
    },
    loadUIData: function(){
        let url = '/api/semi/uidata';
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        });
    },
    loadEmployeeContracts : function(employeeId) {
      let url = '/api/sec/employeecontract';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeecontract');
      if(employeeId != undefined){
         url = this.$helpers.appendParam("employeeId", employeeId, url, '/api/sec/employeecontract'); 
      }
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadSpots : function() {
      
      let url = '/api/sec/spot';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadSkills : function() {
      
      let url = '/api/sec/skill';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/skill');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadEmployeeSkills : function() {
      
      let url = '/api/sec/employeeskill';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadEmployeeAvailabilities : function() {
      
      let url = '/api/sec/employeeavailability';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadEmployeeTypes : function() {
      
      let url = '/api/sec/employeetype';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetype');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadEmployeeRules : function() {
      
      let url = '/api/sec/employeerules';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateUIData: function(data){
       
        this.uiData = data;
        let map =  {};
        for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
            let employeeAvailabilityState = data.employeeAvailabilityStates[i];
            map[employeeAvailabilityState.id] = employeeAvailabilityState;   
        }
        this.employeeAvailabilityStateMap = map;
       
    },
    updateEmployeeTypes: function(data){
        
        let typeMap = {};
        for (let i = 0; i < data.length; i++) {
            typeMap[data[i].id] =data[i];
        }
        this.employeeTypeMap = typeMap;
    },
    updateEmployeeRules: function(data){
        
        let rulesMap = {};
        for (let i = 0; i < data.length; i++) {
           rulesMap[data[i].id] =data[i];
        }
        this.employeeRulesMap = rulesMap;
    },
    updateSpots: function(data){
        var i;
        let tspots = {}
        for (i = 0; i < data.length; i++) { 
            tspots[data[i].id] =data[i];
        }
        this.spotMap = tspots;
    },
    updateEmployeeContratcts: function(data){
        var i;
        let tcontracts = {}
        for (i = 0; i < data.length; i++) {
            
            
            tcontracts[data[i].id] =data[i];
        }
        this.employeeContractMap = tcontracts;
    },
    updateEmployeeAvailabilities: function(data){
        var i;
        let tavailabilities = {}
        for (i = 0; i < data.length; i++) {
            tavailabilities[data[i].id] =data[i];
        }
        this.employeeAvailabilityMap = tavailabilities;
    },
    updateSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.skillMap = tskills;
    },
    updateEmployeeSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.employeeSkillMap = tskills;
    },
    loadTableData : function() {
      
      let url = '/api/sec/employee';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    setOverview: function(data) {
        let overviewA = [];
        var i;
        for (i = 0; i < data.length; i++) {
            this.employeeMap[data[i].id] = data[i]; 
            
            overviewA.push(data[i]);
        }
      
        this.employees = overviewA;
    },
    hideModalWithoutReset (ref) {
        this.employeeerror=false;
        this.$refs[ref].hide();
    },
    resetEmployeeValues(){
        this.employeeerror=false;
        //this.employeeId="";
        this.employeename="";
        this.currentEmployeeRow={};
        this.newEmployee = {
          spotId: null,
          typeId: null,
          title: "Herr",
          prefix: "",
          firstName: "",
          postfix: "",
          lastName: "",
          dob: null,
          gender: "M",
          religion: "",
          socialsecurity: "",
          disability: false,
          driverslicense: false,
          dlExpiry: null,
          firstaidcourse: false,
          faExpiry: null,
          mobilephone:"",
          homephone: "",
          email: "",
          country: 1,
          address: "",
          postalCode: "",
          city: "",
          iban: "",
          bic: "",
          nationality: 1,
          citizenType: 1,
          guardianName: "",
          guardianAddress: ""
      }
    },
    resetContractValues(){
        //this.contractId ="";
        this.currentContractRow={};
        this.employeeContract = {
          jobName: "",
          from: null,
          to: null,
          probationTo: null,
          paymentType: 1,
          payment: 2000,
          weekTimeRegular: 40,
          weekWorkDaysRegular: 5,
          vacationTime: 0,
          employeeCategory: 1,
          employmentType: 1,
          contractType: 1,
          nightWorkerType: 1,
          nightWorkBonusHour: 0,
          nightWorkBonusShift: 0,
          overtimeBonusHour: 0,
          overtimeBonusShift: 0,
          costCenter: "",
          collectiveContract: false,
          collectiveContractType: "",
          collectiveContractRank: 0,
          apprenticeYear: 1,
          comment: ""
        }
      
    },
   
    resetAvailabilityValues(){
        this.currentAvailabilityRow = {};
        this.employeeAvailability = {
          from: "",
          to: "",
          state: 1,
          factor: 1,
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          comment: null,

      }
    },
    resetEmployeeSkillValues(){
        this.currentEmployeeSkillRow = {};
         this.employeeSkill = {
          skillId: "",
          value: 0
        }
    },
   
    hideModal (ref) {
        this.resetEmployeeValues();
        this.resetContractValues(); 
        this.resetAvailabilityValues();
        this.resetEmployeeSkillValues();
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
